<section class="skill-list" id="content" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{lang.skills}}</h2>
      <div class="page-bar">

        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.SKILLS_LIST">{{lang.humanResources }}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.SKILLS_LIST">{{ lang.skills }}</a>
          </li>
        </ul>

        <!-- <div class="social-icons" style="margin-bottom: 0px;float: right;">
          <a class="plus-add" (click)="addDepartment()"
            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
            <i class="fa fa-plus"></i>
          </a>
        </div>            -->
      </div>
   
      

    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <!-- Nav tabs -->
                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <!-- <li role="presentation" class="active"><a href="#listTab" aria-controls="feedTab" role="tab"
                      data-toggle="tab">{{ lang?.list }}</a></li> -->
                  <li role="presentation" class="active"><a href="#skills" aria-controls="skills" role="tab"
                      data-toggle="tab">{{lang?.skills}}</a></li>
                  <li role="presentation"><a href="#skillsanalysis" aria-controls="skillsanalysis" role="tab"
                      data-toggle="tab">{{lang?.skills_analysis}}</a></li>
                  <li role="presentation"><a href="#courseslist" aria-controls="skillsanalysis" role="tab"
                      data-toggle="tab">{{lang?.courses_list}}</a></li>

                  <li role="presentation"><a href="#searchforcourses" aria-controls="searchforcourses" role="tab"
                      data-toggle="tab">{{lang?.search_for_courses}}</a></li>


                  <li role="presentation"><a href="#coursesstatus" aria-controls="coursesstatus" role="tab"
                      data-toggle="tab">{{lang?.courses_status}}</a></li>
                </ul>


                <div class="tab-content">

               

                  <div role="tabpanel" class="tab-pane active" id="skills">
                    <div class="row p-10">

                      <div class="col-sm-3" style="width: 20%;">
                        <div class="social-icons">

                          <a class="plus-add" (click)="addskills()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <i class="fa fa-plus"></i>
                          </a>

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport2"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>

                          <a class="plus-import" data-toggle="modal" data-target="#datatableImport2" data-action="show"
                            data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-import"></span>
                          </a>


                          <a class="plus-copy" (click)="multiSkillsDuplicate()" data-action="show" data-id=""
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiSkillsDelete()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>
                      </div>

                      <div  class="col-sm-9">
                        <input
                        style="float: right;width: 20%;"
                        #search
                        id="skillSearch"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>                         
                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions2" class="table-striped table-sm row-border hover"
                        id="table2" *ngIf="skills_records">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox" value=""><i></i>
                              </label>
                            </th>
                            <th>{{ lang.sno }}</th>
                            <th>{{ lang.skillCode }}</th>
                            <th>{{ lang.description }}</th>
                            <th>{{ lang.repetition }}</th>
                            <th>{{ lang.notificationTime }}</th>
                            <th>{{ lang.levelofcompetence }}</th>
                            <th>{{ lang.employeeToWhichSkillApplies }}</th>
                            <th>{{ lang.action }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let srecord of skills_records let i = index" id="{{srecord.id}}">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{i+1}}</td>
                            <td>  {{ srecord.skill_code }}</td>
                            <td>{{ srecord.skill_description }}</td>
                            <td>{{ srecord.repeat_period }} {{ srecord.rep_types }}</td>
                            <td>{{ srecord.notify_time }}</td>
                            <td>{{ srecord.level_of_competence }}</td>
                            <td>{{ srecord.employee_name }}</td>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="blue_action" (click)="deleteSkills(srecord.id)"><i class="fa fa-trash"></i>
                                      {{ lang.erase }}</a></li>
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="edit_action" (click)="editSkills(srecord.id)"><i class="fa fa-edit"></i> {{
                                      lang.modify }}</a></li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        </tbody>

                      </table>
                    </div>

                  </div>


                  <div role="tabpanel" class="tab-pane" id="skillsanalysis">

                    <accordion [isAnimated]="true" [closeOthers]="true">

                      <accordion-group  *ngFor="let dep_val of departments let i = index"
                        heading="{{lang?.code}} : {{ dep_val.code }} {{lang?.desc}} : {{ dep_val.description}}"
                        class="accordion{{ i + 1 }}">

                        <input type="hidden" name="odval" class="val{{ i + 1 }}" value="{{cnt }}">

                        <div class="row p-10">
                          <div class="col-sm-9">

                            <div class="social-icons">

                              <a class="plus-export omplan{{ i + 1 }}" data-toggle="modal"
                                (click)="sadatatableExport(i+1)" data-options="splash-2 splash-ef-4"><span
                                  class="glyphicon glyphicon-export"></span></a>

                              <a class="plus-import" data-toggle="modal" data-target="#datatableImport2"
                                data-action="show" data-id=""
                                [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                                <span class="glyphicon glyphicon-import"></span>
                              </a>

                              <a class="plus-delete odplus_del{{ i + 1 }}" (click)="multiSkillsAnalysisDelete()" 
                              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                                <span class="glyphicon glyphicon-trash"></span>
                              </a>
                              
                              <input type="hidden" id="dmulval" class="dmulval" value="">

                            </div>

                          </div>

                          <div class="col-sm-3" style="float: right;">
                            <div class="social-icons">
                              <a class="" (click)="add_skills_analysis(dep_val.id)"
                                [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                                <button class="btn btn-success"><i class="fa fa-plus"></i> {{ lang?.insert_skill_analysis }} </button>
                              </a>
                            </div>
                          </div>
                        </div>

                        <div class="form-group" style="overflow: auto;">
                          <table datatable [dtOptions]="datatableOptions3" id="skill-analysis" 
                            class="table-striped table-sm row-border hover satable{{ i + 1 }}">
                            <thead>
                              <tr>
                                <th>Hidden.No</th>
                                <th>
                                  <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                    <input type="checkbox" class="chk{{ i + 1 }}" value="{{ cnt }}"><i></i>
                                  </label>
                                </th>
                                <th>{{lang?.sno}}</th>
                                <th>{{lang?.date}}</th>
                                <th>{{lang?.desc}}</th>
                                <th>{{lang?.employee}}</th>
                                <th>{{lang?.status}}</th>
                                <th>{{lang?.distribution_status}}</th>
                                <th>{{lang?.send_to}}</th>
                                <th>{{lang?.date_send}}</th>
                                <th>{{lang?.action}}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let analysis_view of analyses;let i = index" id="{{analysis_view.id}}">
                                <td>{{i+1}}</td>
                                <td (click)="onchk(analysis_view.employeeId,i + 1)"></td>
                                <td>{{i+1}}</td>
                                <td>{{ analysis_view.skill_analysis_date }}</td>
                                <td>{{ analysis_view.skill_analysis_description }}</td>
                                <td>{{ analysis_view.skillsemp }}</td>
                                <td class="multi_lines_text">
                                  <div [innerHTML]="analysis_view.skills_status"></div>
                                </td>
                                <td>{{ analysis_view.distribution_staus }}</td>
                                <td>{{ analysis_view.sent_to }}</td>
                                <td>{{ analysis_view.date_of_sent }}</td>
                                <td>
                                  <div class="btn-group dropup">

                                    <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                      data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                    <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                      <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                          class="blue_action" (click)="deleteSkills(analysis_view.id)"><i
                                            class="fa fa-trash"></i>
                                          {{ lang.erase }}</a></li>
                                      <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                          class="edit_action" (click)="edit_skills_analysis(dep_val.id,analysis_view.id)"><i
                                            class="fa fa-edit"></i>Modify</a></li>
                                      <li><a [routerLink]="['/'+AppFrontRoutes.EMPLOYEE_VIEW+'/'+analysis_view.id]"
                                          class="blue_action"><i class="glyphicon glyphicon-eye-open"></i>Mail</a>
                                      </li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            </tbody>

                          </table>
                        </div>
                      </accordion-group>
                    </accordion>

                  </div>


                  <div role="tabpanel" class="tab-pane" id="courseslist">
                    <div class="row p-10">

                      <div class="col-sm-3" style="width: 20%;">
                        <div class="social-icons">

                          <a (click)="addEditCourseList('')" class="plus-add"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <i class="fa fa-plus"></i>
                          </a>

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport4"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>

                          <a class="plus-import" data-toggle="modal" data-target="#datatableImport2" data-action="show"
                            data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-import"></span>
                          </a>


                          <a class="plus-copy" (click)="multiCoursesDuplicate()" data-action="show" data-id=""
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiCoursesDelete()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>
                      </div>

                      <div  class="col-sm-9">
                        <input
                        style="float: right;width: 20%;"
                        #search
                        id="courseSearch"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>                         
                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions4" class="table-striped table-sm row-border hover"
                        id="table4" *ngIf="course1">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox" value=""><i></i>
                              </label>
                            </th>
                            <th>{{lang?.sno}}</th>
                            <th>{{lang?.course_code}}</th>
                            <th>{{lang?.title}}</th>
                            <th>{{lang?.course_type}}</th>
                            <th>{{lang?.duration_hours}}</th>
                            <th>{{lang?.part}}.</th>
                            <th>{{lang?.name_of_participants}}</th>
                            <th>{{lang?.place}}</th>
                            <th>{{lang?.start_date}}</th>
                            <th>{{lang?.end_date}}</th>
                            <th>{{lang?.applicable_skills}}</th>
                            <th>{{lang?.teacher}}</th>
                            <th>{{lang?.status}}</th>
                            <th>{{lang?.action}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let cvalue of course1 let i = index" id="{{cvalue.id}}">
                            <td>{{ i + 1 }}</td>
                            <td></td>
                            <td>{{ i + 1 }}</td>
                            <td> <a [routerLink]="['/'+AppFrontRoutes.SKILLS_COURSE_LIST  + '/' + cvalue.id]"
                              class="blue_action"> {{ cvalue.course_code }} </a> </td>
                            <td>{{ cvalue.course_name }}</td>
                            <td>{{ cvalue.ctype }}</td>
                            <td>{{ cvalue.course_hours }}</td>
                            <td>{{ cvalue.total_p }}</td>
                            <td>{{ cvalue.custom_where_employee_name }}</td>
                            <td>{{ cvalue.course_hop }}</td>
                            <td>{{ cvalue.course_start_date }}</td>
                            <td>{{ cvalue.course_end_date }}</td>
                            <td>{{ cvalue.custom_where_in }}</td>
                            <td>{{ cvalue.teacher }}</td>
                            <td>
                              <div [innerHTML]="cvalue.status"></div>
                            </td>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                    class="blue_action" (click)="coursedelete(cvalue.id)"><i
                                      class="fa fa-trash"></i> Erase</a></li>
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a (click)="addEditCourseList(cvalue.id)"
                                    class="edit_action"><i class="fa fa-edit"></i>Modify</a></li>
                                  <li><a [routerLink]="['/'+AppFrontRoutes.SKILLS_COURSE_LIST + '/' + cvalue.id]" class="blue_action"><i class="glyphicon glyphicon-eye-open"></i>View</a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        </tbody>

                      </table>
                    </div>

                  </div>

                  <div role="tabpanel" class="tab-pane" id="searchforcourses">
                    <div class="row p-10">

                      <div class="col-sm-3" style="width: 20%;">
                        <div class="social-icons">

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport5"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>

                        </div>
                      </div>

                      <div class="col-sm-6" style="width: 60%;">
                        <div class="newsearchsection">
                          <input type="text" name="course_name" id="course_name" value="">
                          <!-- search -->
                          <input type="submit" id="search_details" name="search_details" value="{{lang?.search}}"
                            (click)="onSelect()">
                        </div>
                      </div>
                      <input type="hidden" id="csmulval" class="csmulval" value="">


                    </div>

                    <div ng-app="testmyApp" class="form-group">
                      <table datatable [dtOptions]="datatableOptions5" class="table-striped table-sm row-border hover"
                        id="table5" *ngIf="result">
                        <thead>
                          <tr>
                            <th>{{lang?.sno}}</th>
                            <th>{{lang?.employee_name}}</th>
                            <th>{{lang?.employee_sur_name}}</th>
                            <th>{{lang?.tax_code}}</th>
                            <th>{{lang?.email}}</th>
                            <th>{{lang?.course_code}}</th>
                            <th>Cource Attended</th>
                            <th>{{lang?.duration_hours}}</th>
                            <th>{{lang?.start_date}}</th>
                            <th>{{lang?.end_date}}</th>
                            <th>{{lang?.certificate}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let cvalue of result let i = index" id="{{cvalue.id}}">
                            <td>{{ i + 1 }}</td>
                            <td>{{ cvalue.employee_name }}</td>
                            <td>{{ cvalue.employee_surname }}</td>
                            <td>{{ cvalue.employee_tax_code }}</td>
                            <td>{{ cvalue.employee_email }}</td>
                            <td>{{ cvalue.course_code }}</td>
                            <td>{{ cvalue.course_name }}</td>
                            <td>{{ cvalue.course_hours }}</td>
                            <td>{{ cvalue.course_start_date }}</td>
                            <td>{{ cvalue.course_end_date }}</td>
                            <td>{{ cvalue.certificate }}</td>
                          </tr>
                        </tbody>

                      </table>
                    </div>

                  </div>

                  <div role="tabpanel" class="tab-pane" id="coursesstatus" *ngIf="skills_value">

                    <accordion [isAnimated]="true" [closeOthers]="true">

                      <accordion-group  *ngFor="let svalue of skills_value let i = index"
                        heading="{{lang?.skillCode}} : {{ svalue.skill_code }} Description : {{ svalue.skill_description}} {{lang?.status}} : {{ svalue.status_up }}"
                        class="accordion{{ i + 1 }}">


                        <input type="hidden" name="odval" class="val{{ i + 1 }}" value="{{cnt }}">

                        <div class="row p-10">

                          <div class="col-sm-3" style="width: 20%;">
                            <div class="social-icons">

                              <a [routerLink]="['/'+AppFrontRoutes.CREATE_COURSE]" class="plus-add"
                                [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                                <i class="fa fa-plus"></i>
                              </a>

                              <a class="plus-export csplan{{ i + 1 }}" data-toggle="modal"
                                (click)="csdatatableExport(i+1)" data-options="splash-2 splash-ef-4">
                                <span class="glyphicon glyphicon-export"></span>
                              </a>

                              <a class="plus-import" data-toggle="modal" data-target="#datatableImport2"
                                data-action="show" data-id=""
                                [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                                <span class="glyphicon glyphicon-import"></span>
                              </a>

                              <a class="plus-copy" (click)="multiSkillsDuplicate()" data-action="show" data-id=""
                                [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                                <span class="glyphicon glyphicon-file"></span>
                              </a>

                              <a class="plus-delete" *ngIf="deleteOption" (click)="multiSkillsDelete()"
                                [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                                <span class="glyphicon glyphicon-trash"></span>
                              </a>

                            </div>
                          </div>
                        </div>

                        <input type="hidden" class="csvchk" value="{{ cnt }}">

                        <div class="form-group" style="overflow: auto;">
                          <table datatable [dtOptions]="datatableOptions6"
                            class="table-striped table-sm row-border hover cstable{{ i + 1 }}">
                            <thead>
                              <tr>
                                <th>Hidden.No</th>
                                <th>
                                  <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                    <input type="checkbox" class="cschk{{ i + 1 }}" value="{{ cnt }}"><i></i>
                                  </label>
                                </th>
                                <th>{{lang?.sno}}</th>
                                <th>{{lang?.course_code}}</th>
                                <th>{{lang?.title}}</th>
                                <th>{{lang?.course_type}}</th>
                                <th>{{lang?.duration_hours}}</th>
                                <th>{{lang?.part}}</th>
                                <th>{{lang?.name_of_participants}}</th>
                                <th>{{lang?.place}}</th>
                                <th>{{lang?.start_date}}</th>
                                <th>{{lang?.end_date}}</th>
                                <th>{{lang?.teacher}}</th>
                                <th>{{lang?.status}}</th>
                                <th>{{lang?.action}}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let csvalue of svalue.course_status let k = index" id="{{csvalue.id}}">
                                <td>{{ k + 1 }}</td>
                                <td (click)="csonchk(csvalue.id,i + 1)"></td>
                                <td>{{ k + 1 }}</td>
                                <td>{{ csvalue.course_code }}</td>
                                <td>{{ csvalue.course_name }}</td>
                                <td>{{ csvalue.ctype }}</td>
                                <td>{{ csvalue.course_hours }}</td>
                                <td>{{ csvalue.total_p }}</td>
                                <td>{{ csvalue.custom_where_employee_name }}</td>
                                <td>{{ csvalue.course_hop }}</td>
                                <td>{{ csvalue.course_start_date }}</td>
                                <td>{{ csvalue.course_end_date }}</td>
                                <td>{{ csvalue.course_lecture }}</td>
                                <td class="multi_lines_text">
                                  <div [innerHTML]="csvalue.mstat"></div>
                                </td>
                                <td>
                                  <div class="btn-group dropup">

                                    <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                      data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                    <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                      <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                          class="blue_action"><i class="fa fa-trash"></i>
                                          Erase</a></li>
                                      <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                          [routerLink]="['/'+AppFrontRoutes.UPDATE+'/'+svalue.id]"
                                          class="edit_action"><i class="fa fa-edit"></i>Modify</a></li>
                                      <li><a class="blue_action"><i class="glyphicon glyphicon-eye-open"></i>View</a>
                                      </li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            </tbody>

                          </table>
                        </div>
                      </accordion-group>
                    </accordion>

                  </div>

                </div>

              </div>



              <div role="tabpanel" *ngSwitchCase="'calendar'">

                <div class="row p-10">

                  <div class="col-sm-9">
                  </div>

                  <div class="col-sm-3">
                    <div class="social-icons">
                      <a class="plus-export" (click)="setPageView('list')">
                        <span class="glyphicon glyphicon-list"></span>
                      </a>
                      <a class="plus-export" (click)="setPageView('calendar')">
                        <span class="glyphicon glyphicon-calendar"></span>
                      </a>
                    </div>
                  </div>

                </div>

                <app-servicing-calendar></app-servicing-calendar>
              </div>



            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ lang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active Columns</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>
          </div>

          <div class="active-left">
            <h2>{{ lang?.additionalColumns}}</h2>

            <div class="row" *ngFor="let option of datatableAddCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableImport1" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>      
        </div>
         -->

      <div class="modal-header">
        <h4 class="modal-title pull-left">IMPORT DATA</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)">
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a [routerLink]="">Click here</a> to download to csv format file
              </font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <div id="datatableExportBtn2" class="export_dynamic_btn">
          </div> -->
        <button type="button" class="btn btn-primary" (click)="onclick()">Save</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>

      </div>
    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableImport2" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h4 class="modal-title pull-left">IMPORT DATA</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" class="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)">
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a [routerLink]="">Click here</a> to download to csv format file
              </font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <div id="datatableExportBtn2" class="export_dynamic_btn">
          </div> -->
        <button type="button" class="btn btn-primary" (click)="onclick2()">Save</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>

      </div>
    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">SELECT COLUMNS</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i>Select All</label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active columns</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="sadatatableExport3" tabindex="-1" role="dialog" aria-hidden="true"
  style="display: none;">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">SELECT COLUMNS</h3>
      </div>

      <div class="modal-body column_export">
        <input type="hidden" name="scol_val" class="scol_val" value="">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export3_select_deselect_all($event)"><i></i>Select All</label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active columns</h2>

            <div class="row" *ngFor="let option of datatableCols3">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export3_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn3" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport4" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">SELECT COLUMNS</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export4_select_deselect_all($event)"><i></i>Select All</label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active columns</h2>

            <div class="row" *ngFor="let option of datatableCols4">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export4_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn4" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport5" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">SELECT COLUMNS</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export5_select_deselect_all($event)"><i></i>Select All</label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active columns</h2>

            <div class="row" *ngFor="let option of datatableCols5">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export5_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn5" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="csdatatableExport6" tabindex="-1" role="dialog" aria-hidden="true"
  style="display: none;">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">SELECT COLUMNS</h3>
      </div>

      <div class="modal-body column_export">
        <input type="hidden" name="scol_val" class="scol_val" value="">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export6_select_deselect_all($event)"><i></i> Select All </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active columns</h2>

            <div class="row" *ngFor="let option of datatableCols6">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export6_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn6" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>